import axios from 'axios'

const isAxiosCancelOrNetworkError = (error) =>
  axios.isCancel(error)
  || error?.code === 'ERR_CANCELED'
  || error?.name === 'CanceledError'
  || error?.code === 'ERR_NETWORK'
  || (error?.code === 'ECONNABORTED' && error?.message === 'Request aborted')

export default isAxiosCancelOrNetworkError
